import { connect } from 'react-redux';

import CptDashboard from '../components/CptDashboard';
import {
  onCptQueryInputChange,
  loadCptEmployeeOptions,
  initLoadCptEmployeeOptionsActionStatus,
  loadCptInfo,
  initLoadCptInfoActionStatus,
  selectCptInfo,
  openAddOrEditCptModal,
  addOrEditCptChangeInput,
  addOrEditCpt,
  initAddOrEditCptActionStatus,
  resetAddOrEditCptModal,
  submitCptApproval,
  initSubmitCptApprovalActionStatus,
  openDelCptModal,
  delCpt,
  initDelCptActionStatus,
  resetDelCptModal,
  cptNoteChangeInput,
  loadCptNote,
  initLoadCptNoteActionStatus,
  addOrEditCptNote,
  initAddOrEditCptNoteActionStatus,
  resetCptNoteModal,
} from '../CptActions';

import { doOperationRecordAction } from '../../common/operationRcd/OperationRecordActions';

const mapStateToProps = state => {
  return {
    employeeOptions: state.cpt.employeeOptions,
    cptQueryFields: state.cpt.cptQueryFields,
    loadCptEmployeeOptionsActionStatus: state.cpt.loadCptEmployeeOptionsActionStatus,
    loadCptInfoActionStatus: state.cpt.loadCptInfoActionStatus,
    loadCptInfoResp: state.cpt.loadCptInfoResp,
    selectedCptInfoArray: state.cpt.selectedCptInfoArray,
    addOrEditCptModal: state.cpt.addOrEditCptModal,
    addOrEditCptActionStatus: state.cpt.addOrEditCptActionStatus,
    submitCptApprovalRespErrMsg: state.cpt.submitCptApprovalRespErrMsg,
    submitCptApprovalActionStatus: state.cpt.submitCptApprovalActionStatus,
    delCptModal: state.cpt.delCptModal,
    delCptActionStatus: state.cpt.delCptActionStatus,
    cptNoteModal: state.cpt.cptNoteModal,
    loadCptNoteActionStatus: state.cpt.loadCptNoteActionStatus,
    loadCptNoteRespErrMsg: state.cpt.loadCptNoteRespErrMsg,
    addOrEditCptNoteActionStatus: state.cpt.addOrEditCptNoteActionStatus,
    operationRecord: state.operationRecord,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCptQueryInputChange: params => dispatch(onCptQueryInputChange(params)),
    loadCptEmployeeOptions: namePart => dispatch(loadCptEmployeeOptions(namePart)),
    initLoadCptEmployeeOptionsActionStatus: () => dispatch(initLoadCptEmployeeOptionsActionStatus()),
    loadCptInfo: params => dispatch(loadCptInfo(params)),
    initLoadCptInfoActionStatus: () => dispatch(initLoadCptInfoActionStatus()),
    selectCptInfo: array => dispatch(selectCptInfo(array)),
    openAddOrEditCptModal: (mode, data) => dispatch(openAddOrEditCptModal(mode, data)),
    addOrEditCptChangeInput: params => dispatch(addOrEditCptChangeInput(params)),
    addOrEditCpt: params => dispatch(addOrEditCpt(params)),
    initAddOrEditCptActionStatus: () => dispatch(initAddOrEditCptActionStatus()),
    resetAddOrEditCptModal: () => dispatch(resetAddOrEditCptModal()),
    submitCptApproval: (params, actionType) => dispatch(submitCptApproval(params, actionType)),
    initSubmitCptApprovalActionStatus: () => dispatch(initSubmitCptApprovalActionStatus()),
    openDelCptModal: data => dispatch(openDelCptModal(data)),
    delCpt: params => dispatch(delCpt(params)),
    initDelCptActionStatus: () => dispatch(initDelCptActionStatus()),
    resetDelCptModal: () => dispatch(resetDelCptModal()),
    cptNoteChangeInput: params => dispatch(cptNoteChangeInput(params)),
    loadCptNote: () => dispatch(loadCptNote()),
    initLoadCptNoteActionStatus: () => dispatch(initLoadCptNoteActionStatus()),
    addOrEditCptNote: params => dispatch(addOrEditCptNote(params)),
    initAddOrEditCptNoteActionStatus: () => dispatch(initAddOrEditCptNoteActionStatus()),
    resetCptNoteModal: () => dispatch(resetCptNoteModal()),
    doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CptDashboard);
